<button type="button" (click)="open.emit(event().slug)" [attr.aria-label]="'events.viewEventAria' | translate: { title: event().title }"
  class="group relative flex h-88 w-full cursor-pointer flex-col justify-end overflow-hidden rounded-lg border-0 bg-(--pnud-bleu) bg-cover bg-center p-0 text-left shadow-(--shadow-card) transition duration-300 hover:-translate-y-0.5 hover:shadow-(--shadow-raised) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--cmr-jaune)"
  [style.background-image]="coverUrl() ? 'url(' + coverUrl() + ')' : null">

  <div
    class="pointer-events-none absolute inset-0 bg-linear-to-t from-(--marine)/95 via-(--marine)/45 to-(--marine)/5 transition-all duration-300 ease-out group-hover:from-(--marine)/97 group-hover:via-(--marine)/78 group-focus-visible:from-(--marine)/97 group-focus-visible:via-(--marine)/78"
    aria-hidden="true"></div>

  <div class="relative p-5 text-white">
    @if (typeLabelKey()) {
      <span class="text-[11px] font-extrabold uppercase tracking-[0.14em] text-(--cmr-jaune)">{{ typeLabelKey() | translate }}</span>
    } @else if (typeLabelFallback()) {
      <span class="text-[11px] font-extrabold uppercase tracking-[0.14em] text-(--cmr-jaune)">{{ typeLabelFallback() }}</span>
    }
    @if (dateLabel() || locationLabel()) {
      <div class="mt-1 text-[12.5px] font-semibold text-white/80">
        {{ dateLabel() }}{{ dateLabel() && locationLabel() ? ' · ' : '' }}{{ locationLabel() }}
      </div>
    }
    <h3 class="m-0 mt-1.5 text-[17px] font-extrabold leading-tight">{{ event().title }}</h3>
    @if (event().summary) {
      <p
        class="m-0 mt-0 max-h-0 overflow-hidden text-[13px] leading-relaxed text-white/85 opacity-0 transition-all duration-300 ease-out group-hover:mt-2.5 group-hover:max-h-28 group-hover:opacity-100 group-focus-visible:mt-2.5 group-focus-visible:max-h-28 group-focus-visible:opacity-100">
        {{ event().summary }}
      </p>
    }
  </div>
</button>
